import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const setupCheckoutRoutes = {
  name: 'checkout-setup',
  path: 'setup/checkout',
  component: () => import('./SetupCheckout.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
